import { render, staticRenderFns } from "./import-excel.vue?vue&type=template&id=fa2c1dce&scoped=true"
import script from "./import-excel.vue?vue&type=script&lang=js"
export * from "./import-excel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2c1dce",
  null
  
)

export default component.exports